import { getQueryStringParams } from 'lib/utils';
const params = getQueryStringParams();

const defaultText = 'Oi, tudo bem? <br> Eu sou o assistente virtual do shopping e tô aqui pra te ajudar no seu passeio pelo Shopping!';

const startMessage = () => {
  return {
    id: 'mk-chat-' + Math.random().toString(),
    typing: {
      duration: 1500
    },
    type: 'text',
    owner: 'bot',
    text: params['startMessage'] ? params['startMessage'] : defaultText,
  }
};

const createSuggestion = (message) => {
  if (message) {
    return {
      label: message,
      value: message
    }
  }
}

const startSuggestion = () => {
  const items = [];
  if(params['suggestion1']) items.push(createSuggestion(params['suggestion1']));
  if(params['suggestion2']) items.push(createSuggestion(params['suggestion2']));
  if(params['suggestion3']) items.push(createSuggestion(params['suggestion3']));
  if(params['suggestion4']) items.push(createSuggestion(params['suggestion4']));
  if(params['suggestion5']) items.push(createSuggestion(params['suggestion5']));
  if(params['suggestion6']) items.push(createSuggestion(params['suggestion6']));
  if(params['suggestion7']) items.push(createSuggestion(params['suggestion7']));
  return {
    id: Math.random().toString(),
    typing: {
      wait: 150
    },
    type: 'quickReplies',
    owner: 'bot',
    items: items,
  }
}

export const getStartMessage = () => {
  return [
    startMessage(),
    startSuggestion(),
  ];
}